import Vue from "vue";
import App from "./App";
import Buefy from "buefy";
//import "buefy/dist/buefy.css";
import router from "./router";
import store from "@/store";
import VueJWT from "vuejs-jwt";
import "leaflet/dist/leaflet.css";
import VueApexCharts from "vue-apexcharts";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css";

("");

Vue.use(VueJWT, {
  signKey: "c4pt1v3_19p1"
});

Vue.use(Buefy, {
  defaultIconPack: "fas"
});

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
Vue.use(Vuesax, {
  // options here
});
Vue.use(Vuetify);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",

  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js